import React from 'react';
import { Database, Copy } from 'lucide-react';



interface AssetDNSRecordsProps {
  records: any;
}

export const AssetDNSRecords: React.FC<AssetDNSRecordsProps> = ({ records }) => {
  return (
    <div className="bg-[#0F1629] rounded-xl p-6 border border-gray-800/50">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Database className="h-5 w-5 text-blue-500" />
          <h2 className="text-lg font-semibold text-white">DNS Records</h2>
        </div>
        <span className="text-sm text-gray-400">{records.length} records</span>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-800">
              <th className="px-4 py-3 text-left text-sm font-medium text-gray-400">Type</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-gray-400">Name</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-gray-400">Value</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-gray-400">TTL</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-gray-400">Priority</th>
              <th className="px-4 py-3 text-right text-sm font-medium text-gray-400">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-800">
            {records.map((record: any, index: number) => (
              <tr key={index} className="group hover:bg-gray-800/30">
                <td className="px-4 py-3">
                  <span className="inline-flex items-center px-2 py-1 rounded-lg bg-gray-800/50 text-xs font-medium text-white">
                    {record.type}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-white">{record.name}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-white">{record.data}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-gray-400">{record.ttl }s</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-gray-400">
                    {record.priority || '-'}
                  </span>
                </td>
                <td className="px-4 py-3 text-right">
                  <button className="p-1 rounded-lg hover:bg-gray-800/50 text-gray-400 hover:text-white transition-colors">
                    <Copy className="h-4 w-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};